import { createAsyncThunk } from '@reduxjs/toolkit'
import { ApiError } from '@user/store/agreements/typings'
import {
  ClosedWonQueueSubmissionsInput,
  ClosedWonQueueSubmissionsDashboardDTO,
  IDashboardPreference,
} from './typings'
import { get, post } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { IUserPreferenceDashboard } from '@user/store/userPreferences/typings'
import {
  ISearchResponse,
  pageToSearchInput,
  searchInputToQueryString,
} from '@sales-center/common'

export const getClosedWonQueueSubmissions = createAsyncThunk<
  ISearchResponse<ClosedWonQueueSubmissionsDashboardDTO>,
  { page: number; query?: string },
  { rejectValue: ApiError }
>(
  'dashboard/closedWonQueueSubmissions/getData',
  async ({ page, query }, thunkApi) => {
    const resultsPerPage = 3
    const qstring = searchInputToQueryString(
      pageToSearchInput(page, resultsPerPage, query),
    )
    const response = await get(
      `${ServiceConfig.baseAPIUrl}/Dashboard/closedWonQueueSubmissions?${qstring}`,
    )

    if (response.ok) {
      return await response.json()
    }
    return thunkApi.rejectWithValue((await response.json()) as ApiError)
  },
)

export const getPrefs = createAsyncThunk<IDashboardPreference, void>(
  'usersPreferences/Dashboard/getByType',
  async (_, thunkApi) => {
    const response = await get(
      `${ServiceConfig.baseAPIUrl}/UserPreferences/Dashboard/Type/CWQS`,
    )
    if (response.ok) {
      return await response.json()
    }
    return thunkApi.rejectWithValue((await response.json()) as ApiError)
  },
)

export const postPrefs = createAsyncThunk<
  IUserPreferenceDashboard,
  ClosedWonQueueSubmissionsInput
>(
  'usersPreferences/Dashboard/closedWonQueueSubmissions/post',
  async (userPref, thunkApi) => {
    const response = await post(
      `${ServiceConfig.baseAPIUrl}/UserPreferences/dashboard`,
      userPref,
    )
    if (response.ok) {
      const result: IUserPreferenceDashboard = await response.json()
      return result
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)
